<template>
  <div class="add-product">
    <Modal v-model="visible" :mask-closable="false" :closable="!okBthDisabled" width="1200" class="add-product-modal" :footer-hide="true"  :transfer="false">
      <div solt="title" class="title-box">
        <div class="modal-title">新增产品</div>
      </div>
      <div class="search-box btn3">
        <div class="input-item">
            <span class="label">产品名称</span>
            <Input v-model="searchParams.productName" placeholder="请输入产品名称" />
        </div>
        <div class="input-item">
            <span class="label">产品编码</span>
            <Input v-model="searchParams.productCode" placeholder="请输入产品编码" />
        </div>
        <div class="input-item">
            <span class="label">保险公司</span>
            <Select v-model="searchParams.companyCode" transfer placeholder="请选择保司" clearable filterable>
              <Option v-for="(item,index) in companyList" :value="item.code" :key="index">{{ item.name }}</Option>
            </Select>
        </div>
        <div class="input-item">
            <span class="label">上架状态</span>
            <Select v-model="searchParams.publishStatus" transfer placeholder="请选择上架状态" clearable>
              <Option value="1">已下架</Option>
              <Option value="2">已上架</Option>
            </Select>
        </div>
        <div class="input-item">
            <span class="label">销售状态</span>
            <Select v-model="searchParams.salesStatus" transfer placeholder="请选择销售状态" clearable>
              <Option value="1">停售</Option>
              <Option value="2">在售</Option>
            </Select>
        </div>
        <div class="input-item" v-if="$units.superviseShowVal() && showSupplier">
            <span class="label">供应商类型</span>
            <RadioGroup v-model="searchParams.supplierType" @on-change="changeOriginSupplierType">
              <Radio label="">全部</Radio>
              <Radio label="1">保司</Radio>
              <Radio label="2">通道</Radio>
            </RadioGroup>
          </div>
          <div v-if="searchParams.supplierType && $units.superviseShowVal() && showSupplier" class="input-item">
            <span class="label">供应商</span>
            <Select v-model="searchParams.supplierIds" multiple :max-tag-count="4"  clearable filterable transfer>
              <Option v-for="item in supplierList" :key="item.value" :value="item.value">{{ item.label }}</Option>
            </Select>
          </div>
          <div class="input-item">
              <span class="label">业务类别</span>
              <Select v-model="searchParams.sellType" clearable>
                <Option value="1">网销</Option>
                <Option value="3">经代</Option>
              </Select>
            </div>
          <div class="btn-item">
            <Button type="primary" @click="searchAjax">查询</Button>
          </div>
       </div>
      <Tabs v-model="tabActive" @on-click="getThemeList2">
        <TabPane label="全部" name=""></TabPane>
        <TabPane :label="item.name" :name="item.id" v-for="(item,i) in themeList" :key="i"></TabPane>
      </Tabs>
      <ul class="type-list" v-if="tabActive&&themeList2.length">
        <li :class="{'active':tabActive2==''}" @click="tabActive2='';searchAjax()">全部</li>
        <li :class="{'active':tabActive2==item.id}" @click="tabActive2=item.id;searchAjax()" v-for="(item,i) in themeList2" :key="i" >{{item.name}}</li>
      </ul>
      <!-- 工具栏 -->
      <div class="tools-box">
        <div class="left-box">
          <Checkbox v-model="isAll" @on-change="selectAll">全部产品</Checkbox>
        </div>
        <div class="right-box">
          <span class="text">已选择<span>{{isAll?total:selectArr.length}}</span>项,共<span>{{total}}</span>款产品</span>
        </div>
      </div>
      <!-- 表格 -->
      <div class="table-box" v-if="visible">
        <loading :isShow="tableLoading" />
        <Table :columns="columns" :data="tableData" @on-select="onSelect" @on-select-cancel="onSelectCancel"
          @on-select-all="onSelect" @on-select-all-cancel="onSelectAllCancel" @on-sort-change="sort">
          <template slot-scope="{ row }" slot="insureCost">
            <div>
              {{row.insureCost}}元起
            </div>
          </template>
          <template slot-scope="{ row }" slot="publishStatus">
            <span v-if="row.publishStatus == 2">已上架</span>
            <span v-else>已下架</span>
          </template>
          <template slot-scope="{ row }" slot="salesStatus">
            <span v-if="row.salesStatus == 2">在售</span>
            <span v-else>停售</span>
          </template>
          <template slot-scope="{ row }" slot="fee">
            <div :class="{'red-text':row.isTemplate==0}" >
              <template v-if="row.min!=row.max">
                <span>{{row.min}}%</span>-<span>{{row.max}}%</span>
              </template>
              <span v-else>{{row.min}}%</span>
            </div>
          </template>
        </Table>
        <Page :total="total" :current.sync="pageNum" :page-size="pageSize"
          show-total @on-change="getList" style="text-align: center; margin-top: 20px"/>
      </div>
      <div class="ivu-modal-footer" v-if="tableData.length">
        <Button @click="visible=false" :disabled="okBthDisabled">取消</Button>
        <Button type="primary" @click="ok" :loading="loading" :disabled="okBthDisabled">确定</Button>
      </div>
    </Modal>
  
    <Modal v-model="successVisible" :mask-closable="!detail.isNewTemplate" :closable="!detail.isNewTemplate" width="800" :footer-hide="true" class="my-modal top p-b">
      <div class="add-product-success-modal">
        <img src="@static/images/success.png">
        <div class="title-text">产品添加成功</div>
        <div class="info-text" v-if="detail.isNewTemplate">您需为新增产品配置服务费比例</div>
        <!-- <Button type="primary" v-if="detail.isNewTemplate" ghost @click="prev">上一步</Button> -->
        <Button type="primary" v-if="detail.isNewTemplate" ghost @click="successVisible = false">稍后配费</Button>
        <Button type="primary" v-if="detail.isNewTemplate" @click="openBatchSetting" >批量配费</Button>
      </div>
    </Modal>
  
    <!-- 批量配置 -->
    <batchSetting 
      ref="batchSetting" 
      @success="$emit('success')" 
      @error="visible=true" 
      :isTop="isTop"
      @sync-organization-product="syncOrganizationProduct"
    >
    </batchSetting>
  </div>
  
</template>
  
<script>
  import { mapState } from "vuex";
  import batchSetting from "./batchSetting";
  export default {
    components: {batchSetting},
    props: {
      isTop:null,
      showSupplier:{
      default:true,
      type:Boolean
    }},
    data() {
      return {
        detail: {},
        themeList2: [],//2级产品分类
        successVisible: false,//成功弹窗
        isAll: false,
        publishStatus:'',
        salesStatus:'',//销售状态
        tabActive: 0,//激活的tab
        tabActive2: "",//2级分类
        searchParams:{},
        companyList:[],
        tableLoading: false,//表格loading
        supplierList:[],
        columns: [],
        sortNo:"",
        tableData: [],//表格数据
        total: 0,//表格记录数
        pageSize: 10,//页容量
        pageNum: 1,//当前页
        selectArr: [],//表格选择的数据
        visible: false,
        loading:false,
        okBthDisabled:false
      };
    },
  
    computed:{
      ...mapState({
        themeList: "themeList",//产品分类
      }),
    },
  
    methods: {
      changeOriginSupplierType(value) {
        this.searchParams.supplierIds = [];
        if (!value) {
          this.supplierList = [];
          return;
        }
        this.$http({
          url:
            value == 1
              ? "/buz/insuranceCompany/read/list"
              : "/buz/insuranceChannel/read/list",
          type: "POST",
          data: {}
        }).then(res => {
          if (value) {
            this.supplierList = res.data.map(i => {
              return {
                value: i.id,
                label: i.name
              };
            });
          } else {
            this.supplierList = [];
          }
        });
      },
      /**
       * 打开当前组件
       * item:{
       *  templateId:模板id,
       *  orgId:机构id,
       *  type:模板类型,
       * }
       */
      open(item){
        console.log('showSupplier',this.showSupplier)
        this.detail = item;
        this.isAll = false;
        this.tableData = [];
        this.selectArr = [];
        this.tabActive = 0;
        this.tabActive2 = "";
        this.sortNo = "";
        this.searchParams = {publishStatus:'2'}
        this.$store.dispatch("getThemeList");
        if(this.$units.superviseShowVal() && this.showSupplier){
          this.columns = [
            {
              type: "selection",
              width: 60,
              align: "center",
            },
            {
              title: "产品名称",
              key: "productName",
              align: "center",
              minWidth: 200,
            },
            {
              title: "产品编码",
              key: "productCode",
              align: "center",
              width: 120,
            },
            {
              title: "上架状态",
              slot: "publishStatus",
              align: "center",
            },
            {
              title: "销售状态",
              slot: "salesStatus",
              align: "center",
            },
            {
              title: "供应商",
              key: "supplierName",
              align: "center",
              minWidth: 100
            },
            {
              title: "保费",
              slot: "insureCost",
              align: "center",
              minWidth: 100,
              sortable: 'custom'
            },
            {
              title: "服务费",
              slot: "fee",
              minWidth: 100,
              align: "center",
            }
          ]
        }else{
          this.searchParams.supplierType = '1';
          this.columns = [
            {
              type: "selection",
              width: 60,
              align: "center",
            },
            {
              title: "产品名称",
              key: "productName",
              align: "center",
              minWidth: 200,
            },
            {
              title: "产品编码",
              key: "productCode",
              align: "center",
              width: 120,
            },
            {
              title: "上架状态",
              slot: "publishStatus",
              align: "center",
            },
            {
              title: "销售状态",
              slot: "salesStatus",
              align: "center",
            },
            {
              title: "保费",
              slot: "insureCost",
              align: "center",
              minWidth: 100,
              sortable: 'custom'
            },
            {
              title: "服务费",
              slot: "fee",
              minWidth: 100,
              align: "center",
            }
          ]
        }
        this.searchAjax();
        this.queryInsuranceCompanyList();
        this.visible = true;
      },
      // 查询签约保司
      queryInsuranceCompanyList() {
          this.$http({
              url: '/buz/insuranceCompany/read/list',
              type: 'POST',
              data: {
                companyType: '1'
              }
          }).then(res => {
              this.companyList = res.data;
          });
      },
      // 全部选择
      selectAll(status){
        const tableData = JSON.parse(JSON.stringify(this.tableData));
        tableData.forEach(item=>{
          item._disabled = status;
          item._checked = status;
        });
        this.tableData = tableData;
        this.selectArr = [];
      },
      // 获取2级分类
      getThemeList2(){
        this.searchAjax();
        if(this.tabActive==0){
          return;
        }
        this.$http({
          url: "/buz/productTheme/array/second",
          type: "get",
          data:{
            parentId:this.tabActive
          }
        }).then(res=>{
          this.tabActive2="";
          this.themeList2 = res.data;
        })
      },
      ok(){
        if(!this.isAll&&this.selectArr.length==0){
          this.$notice.alert("请至少选择一个产品");
          return;
        }
        var params;
        // 费用模板添加产品
        if(this.detail.isCommissionConfig){
          params = {
            templateId:this.detail.template.id,
            templateType:this.detail.template.type,
            isNewTemplate:false,
            themeId: this.tabActive2||this.tabActive||'',
            ...this.searchParams,
            organizationType: this.detail.nodeType,
            organizationId:this.detail.id,
            productCodes:this.selectArr
          }
        }else{
          params = {
            templateId:this.detail.template.id,
            templateType:this.detail.template.type,
            isNewTemplate:false,
            themeId: this.tabActive2||this.tabActive||'',
            ...this.searchParams,
          }
          if(this.selectArr.length){
            params.productCodes = this.selectArr.map(item=>item.productCode)
          }
        }
  
        if(this.isAll){
          params.isAll = 1;
          delete params.productCodes
        }else{
          params.isAll = 0;
        }
  
        if(this.tableLoading){
          return;
        }
  
        this.tableLoading = true;
        this.loading = true;
        this.okBthDisabled = true;
        this.$http({
          url: this.detail.isCommissionConfig?"/buz/organizationProduct/batchAdd":"/buz/templateProduct/batchAdd",
          type: "post",
          data: params
        }).then(res=>{
          this.$emit("success");
          this.visible = false;
          // 没有配置模板
          if(!this.detail.template.id){
            const isLongOrShort = [false,false];
            const productCodes = [];
            this.selectArr.forEach(item=>{
              productCodes.push(item.productCode);
              if(item.productType==1){
                isLongOrShort[0]=true;
              }
              if(item.productType==2){
                isLongOrShort[1]=true;
              }
            });
            this.$refs.batchSetting.open({
              isAll: this.isAll,
              orgId: this.detail.id,
              isLongOrShort: isLongOrShort,
              productCodes: this.isAll?[]:productCodes,
              type: this.detail.nodeType,
              isConfig:true,
              isCommon:true,
              organizationProducts:res.data
            });
          }else if(this.detail.isNewTemplate){
            this.successVisible = true;
          }else{
            this.$notice.success("产品添加成功");
          }
          // 费用配置-配置了模板并新增产品后调用
          if(this.detail.isCommissionConfig && this.detail.template.id) {
            this.syncOrganizationProduct(res.data);
          }
        }).finally(()=>{
          this.tableLoading = false;
          this.loading = false;
          this.okBthDisabled = false;
        })
      },
  
      syncOrganizationProduct(data) {
        this.$http({
          url: "/buz/organizationProduct/syncOrganizationProduct",
          type: "POST",
          data: {
            organizationType: this.detail.nodeType,
            organizationId:this.detail.id,
            organizationProducts:data
          }
        })
      },
  
      // 上一步
      prev(){
        this.successVisible = false;
        this.visible = true;
        // 组件会丢失选中状态，从新记录
        const tableData = JSON.parse(JSON.stringify(this.tableData));
        tableData.forEach(item=>{
          this.selectArr.forEach(item2=>{
            if(item.id==item2.id){
              item._checked = true;
            }
          });
        });
        this.tableData = tableData;
      },
      // 打开批量配置
      openBatchSetting(){
        this.successVisible = false;
        let detail = JSON.parse(JSON.stringify(this.detail));
        detail.productCodes = this.selectArr.map(item=>item.productCode);
        detail.isAll = true;
        detail.isCommon = true;
        this.$refs.batchSetting.open(detail, true);
      },
      // 获取列表参数
      getParams(){
        const params = {
          nodeType: this.detail.nodeType,
          templateId: this.detail.template.id,
          themeId: this.tabActive2||this.tabActive||'',
          handleSource:this.detail.handleSource == 2? 2 : 1,//2.费用配置、1.费用模板
          id:this.detail.id,
          ...this.searchParams
        };
  
        if(this.sortNo){
          params.sortNo = this.sortNo;
          params.orderBy = "1";
        }
        // 费用配置去掉templateId参数
        if(this.detail.handleSource==2){
          delete params.templateId
        }
        return params;
      },
      // 获取列表数据
      getList(){
        const params = this.getParams();
        params.pageNo = this.pageNum;
        params.pageSize = this.pageSize;
        this.tableLoading = true;
        if(this.detail.handleSource==1){
          params.templateId = this.detail.template.id;
        }
        if(!this.$units.superviseShowVal() || !this.showSupplier){
            delete params.supplierType
        }
        this.$http({
          url: this.isTop?"/buz/organizationProduct/sys/query/page":"/buz/organizationProduct/queryNewAdd",
          type: "POST",
          data: params
        }).then(res=>{
          res.data.forEach(item=>{
            this.selectArr.forEach(item2=>{
              if(item.id == item2.id) {
                item._checked = true;
              }
            })
            if(this.isAll){
              item._checked = true;
              item._disabled = true;
            }
          })
          this.tableLoading = false;
          this.tableData = res.data;
          this.total = res.total;
        }).catch(res=>{
          this.tableLoading = false;
        })
      },
      // 排序
      sort(e){
        if(e.order == "asc"){
          this.sortNo = "1";
        }else if(e.order == "desc"){
          this.sortNo = "2";
        }else{
          this.sortNo = "";
        }
        this.searchAjax();
      },
      // 查询
      searchAjax(){
        this.pageNum = 1;
        this.getList();
      },
      // 列表选中
      onSelect(selectArr){
        selectArr.forEach(item=>{
          this.selectPush(item);
        });
      },
      // 列表单个取消选中
      onSelectCancel(selectArr,row){
        this.selectDel(row)
      },
      // 列表全选取消
      onSelectAllCancel(){
        this.tableData.forEach(item=>{
          this.selectDel(item);
        });
      },
      // 添加选择数据
      selectPush(data){
        let has = false;
        this.selectArr.forEach(item=>{
          if(item.id == data.id){
            has = true;
          }
        });
        if(!has){
          this.selectArr.push(data);
        }
      },
      // 去掉选择数据
      selectDel(data){
        this.selectArr.forEach((item,i)=>{
          if(item.id == data.id){
            this.selectArr.splice(i,1);
          }
        });
      }
    },
  };
  </script>
  <style lang="scss" scoped>
  @import "./addProduct.scss";
  </style>
  